import React from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import styles from './no-survey.module.css';

const NoSurvey = ({ userName }) => {
  const [t] = useTranslation();
  return (
    <Row align="center">
      <Col className={styles.text_wrapper}>
        <h2 className="confirmSurvey_text__no-survey">
          {` ${t(
            'pages.data.confirmSurvey.errorNoInstrumentText1'
          )} ${userName}  ${t(
            'pages.data.confirmSurvey.errorNoInstrumentText2'
          )}`}
        </h2>
      </Col>
    </Row>
  );
};

NoSurvey.defaultProps = {
  userName: '',
};

export default NoSurvey;
